import { cn } from "../../lib/utils.ts";

export const OutlookIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      role="img"
      aria-label="Outlook"
      className={cn(className)}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="6.25" y="0.833496" width="12.5" height="17.8571" rx="2.28571" fill="#1066B5" />
      <rect
        x="6.25"
        y="0.833496"
        width="12.5"
        height="17.8571"
        rx="2.28571"
        fill="url(#outlook-grad-0)"
      />
      <rect x="6.25" y="2.74658" width="6.25" height="6.37755" fill="#32A9E7" />
      <rect x="6.25" y="9.12451" width="6.25" height="6.37755" fill="#167EB4" />
      <rect x="12.5" y="9.12451" width="6.25" height="6.37755" fill="#32A9E7" />
      <rect x="12.5" y="2.74658" width="6.25" height="6.37755" fill="#58D9FD" />
      <mask
        id="outlook-mask"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="5"
        y="8"
        width="15"
        height="11"
      >
        <path
          d="M5 8.48633H17.7143C18.9767 8.48633 20 9.50968 20 10.772V16.4047C20 17.6671 18.9767 18.6904 17.7143 18.6904H7.28571C6.02335 18.6904 5 17.6671 5 16.4047V8.48633Z"
          fill="url(#outlook-grad-1)"
        />
      </mask>
      <g mask="url(#outlook-mask)">
        <path d="M20 8.48633V11.0373H18.75V8.48633H20Z" fill="#135298" />
        <path d="M20 18.6903V9.76172L4.375 18.6903H20Z" fill="url(#outlook-grad-2)" />
        <path d="M5 18.6903V9.76172L20.625 18.6903H5Z" fill="url(#outlook-grad-3)" />
      </g>
      <path
        d="M5 8.72642C5 6.83288 6.53502 5.29785 8.42857 5.29785H9.07143C10.965 5.29785 12.5 6.83288 12.5 8.72642V13.3489C12.5 15.2424 10.965 16.7774 9.07143 16.7774H5V8.72642Z"
        fill="black"
        fillOpacity="0.3"
      />
      <rect y="4.02197" width="11.25" height="11.4796" rx="2.28571" fill="url(#outlook-grad-4)" />
      <path
        d="M8.75 9.80618V9.70019C8.75 7.86289 7.45451 6.57324 5.63489 6.57324C3.80538 6.57324 2.5 7.87172 2.5 9.71785V9.82385C2.5 11.6611 3.79549 12.9508 5.625 12.9508C7.44462 12.9508 8.75 11.6523 8.75 9.80618ZM7.2765 9.82385C7.2765 11.0428 6.60403 11.776 5.63489 11.776C4.66574 11.776 3.98339 11.0252 3.98339 9.80618V9.70019C3.98339 8.48121 4.65585 7.74805 5.625 7.74805C6.58426 7.74805 7.2765 8.49887 7.2765 9.71785V9.82385Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="outlook-grad-0"
          x1="6.25"
          y1="9.76207"
          x2="18.75"
          y2="9.76207"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#064484" />
          <stop offset="1" stopColor="#0F65B5" />
        </linearGradient>
        <linearGradient
          id="outlook-grad-1"
          x1="5"
          y1="16.63"
          x2="20"
          y2="16.63"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B366F" />
          <stop offset="1" stopColor="#2657B0" />
        </linearGradient>
        <linearGradient
          id="outlook-grad-2"
          x1="20"
          y1="14.226"
          x2="5"
          y2="14.226"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#44DCFD" />
          <stop offset="0.453125" stopColor="#259ED0" />
        </linearGradient>
        <linearGradient
          id="outlook-grad-3"
          x1="5"
          y1="14.226"
          x2="20"
          y2="14.226"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#259ED0" />
          <stop offset="1" stopColor="#44DCFD" />
        </linearGradient>
        <linearGradient
          id="outlook-grad-4"
          x1="0"
          y1="9.76177"
          x2="11.25"
          y2="9.76177"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#064484" />
          <stop offset="1" stopColor="#0F65B5" />
        </linearGradient>
      </defs>
    </svg>
  );
};
